import React, { useEffect } from 'react';
import useWindowSize from '@revolt-digital/use-window-size';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { CloseSquare, Logout, HambergerMenu } from 'iconsax-react';
import { useDispatch, useSelector } from 'react-redux';
import routes from 'constants/routes';
import { TABLET_BREAKPOINT } from 'constants/breakpoints';
import { useRefs } from 'hooks/useRefs';
import { Button, Logo } from 'components';
import { toggleSideMenu, setCompanies, selectCompany } from 'store/actions/general';
import { logout } from 'store/actions/user';
import { resetTables } from 'store/actions/table';
import { RootState } from 'types/store';
import useApi from 'hooks/useApi';
import endpoints from 'constants/endpoints';
import Select from 'components/dynamicInputs/select';

const Toolbar = () => {
  const windowSize = useWindowSize();
  const { toolbarMiddleRef, extraButtonsRef } = useRefs();
  const { mobileSideMenuOpen, companies = [], selectedCompanyId } = useSelector((state: RootState) => state.general);
  const companyOptions = companies.map(c => ({ value: c.id, label: c.legal_name }));
  const dispatch = useDispatch();
  const { fetchData } = useApi();

  const handleLogout = () => {
    dispatch(logout());
    dispatch(resetTables());
  };

  const handleToggleSideMenu = () => {
    dispatch(toggleSideMenu());
  };

  const handleSelectCompany = (companyId: string) => {
    dispatch(selectCompany(companyId));
  };

  useEffect(() => {
    const loadCompanies = async () => {
      const response = await fetchData(endpoints.GET_CHECK_COMPANY, undefined);
      if (response && response.results) {
        const mapped = response.results.map((c: any) => ({ id: c.id, legal_name: c.legal_name }));
        dispatch(setCompanies(mapped));
      }
    };

    loadCompanies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classnames('toolbar', { 'menu-open': mobileSideMenuOpen })}>
      <div>
        <Button
          className="menu-button"
          variant="alternative"
          icon={mobileSideMenuOpen ? <CloseSquare color="white" /> : <HambergerMenu color="white" />}
          onClick={handleToggleSideMenu}
        />
        <Link to={routes.ACCOUNTS} className="logo-link">
          <Logo full={windowSize.width > TABLET_BREAKPOINT} contrast={windowSize.width > TABLET_BREAKPOINT} />
        </Link>
      </div>
      <div className="middle-slot" ref={toolbarMiddleRef} />
      {/* TODO, when multiple companies are implemented, this will be shown */}
      <div className="company-selector" style={{ display: 'none' }}>
        {companies.length > 0 && (
          <Select
            value={selectedCompanyId || (companies[0] && companies[0].id) || ''}
            options={companyOptions}
            onChange={handleSelectCompany}
            disabled
          />
        )}
      </div>
      <div>
        <div className="extra-buttons-slot" ref={extraButtonsRef} />
        <Button variant="primary" small icon={<Logout color="white" />} onClick={handleLogout} />
      </div>
    </div>
  );
};

export default Toolbar;
